/**
 * Environment settings, resolved at runtime: /config.js (written when the container starts) overrides the
 * build-time import.meta.env values. Mirrors appEnv in @repo/core/config, which this package doesn't depend on.
 */
export const appEnv: ImportMetaEnv = {
  ...import.meta.env,
  ...(typeof window === 'undefined'
    ? undefined
    : (window as Window & { __APP_CONFIG__?: Partial<ImportMetaEnv> }).__APP_CONFIG__)
};
